import { get } from 'lodash';
import { SANTA_MEMBERS_APP_ID } from '../../constants/members-area';

const getCommunitiesContext = (state: any) => state.communitiesContext;

const getApplicationConfigFromContext = (communitiesContext: any, appDefinitionId: any) =>
  get(communitiesContext, appDefinitionId, {});

const getApplicationConfig = (state: any, appDefinitionId: any) =>
  getApplicationConfigFromContext(getCommunitiesContext(state), appDefinitionId);

export const getIsMemberAreaInstalled = (state: any) =>
  Boolean(getApplicationConfig(state, SANTA_MEMBERS_APP_ID).isInstalled);
